import getLargestImage from 'src/utils/get_largest_image';

export function getEventLogo(event: any, lang: string): any {
	if (!event) return null;

	if (lang === 'fa') {
		return event.logo_fa ?? event.logo ?? null;
	}

	return event.logo_en ?? event.logo ?? null;
}

export function getEventFeaturedImage(event: any, lang: string): any {
	if (!event) return null;

	if (lang === 'fa') {
		return event.featured_image_fa ?? event.featured_image ?? null;
	}

	return event.featured_image_en ?? event.featured_image ?? null;
}

export function getEventFeaturedImageUrl(event: any, lang: string): any {
	const featuredImage = getEventFeaturedImage(event, lang);
	const imageLargest = featuredImage ? getLargestImage(featuredImage) : null;

	if (imageLargest) {
		return `${process.env.API_URL}/${imageLargest}`;
	}

	return null;
}

export function getEventFavIcon(event: any, lang: string): any {
	if (!event) return null;

	let favicon;
	if (lang === 'fa') {
		favicon = event.favicon_fa ?? null;
	} else {
		favicon = event.favicon_en ?? null;
	}

	if (favicon) {
		return `${process.env.API_URL}/${favicon}`;
	}

	const logo = getEventLogo(event, lang);
	const logoLargest = logo ? getLargestImage(logo) : null;
	if (logoLargest) {
		return `${process.env.API_URL}/${logoLargest}`;
	}

	return null;
}
